export const ARCHITECTURE_PIPELINE = [
  {
    id: "crm",
    title: "CRM / Source Systems",
    icon: "database",
    color: "#38bdf8",
    summary: "Where customer data originates — Sales/Service Cloud, Marketing Cloud, POS systems, mobile apps, and websites.",
    details: [
      "Every Data Cloud journey starts with source systems: Salesforce CRM, Marketing Cloud, e-commerce platforms, POS systems, and custom apps.",
      "These systems hold fragmented, siloed views of the same customer — an email in Marketing Cloud, a purchase in a POS system, a support case in Service Cloud.",
      "Data Cloud's entire purpose is to unify these fragments into one real-time customer view.",
    ],
  },
  {
    id: "data-stream",
    title: "Data Stream",
    icon: "waves",
    color: "#f59e0b",
    summary: "Connectors that bring source data into Data Cloud — via batch sync or real-time streaming.",
    details: [
      "A Data Stream is the ingestion connector — it pulls data from a source (CRM, S3, Ingestion API, Web/Mobile SDK) into Data Cloud.",
      "Batch Data Streams sync on a schedule (hourly/daily); the Ingestion API and Web/Mobile SDK support real-time streaming for events like clicks or app opens.",
      "Each Data Stream maps its source fields into a Data Lake Object as the very next step.",
    ],
  },
  {
    id: "data-lake",
    title: "Data Lake Object (DLO)",
    icon: "layers",
    color: "#a78bfa",
    summary: "Raw, ingested data lands here exactly as it arrived from the source — before any harmonization.",
    details: [
      "A DLO stores the raw, ingested data in its native source shape — no transformation has happened yet.",
      "DLOs are the 'staging' layer: useful for troubleshooting ingestion, but not meant to be queried directly by Segments or Calculated Insights.",
      "The next step — mapping — transforms DLOs into the harmonized Data Model Objects that the rest of Data Cloud actually uses.",
    ],
  },
  {
    id: "identity-resolution",
    title: "Identity Resolution",
    icon: "fingerprint",
    color: "#fb7185",
    summary: "Stitches records from multiple sources into a single Unified Individual using Match & Reconciliation Rules.",
    details: [
      "Identity Resolution runs as a batch job that compares records across sources using Match Rules (exact or fuzzy matching on email, phone, name+address).",
      "When two or more source records are determined to be the same person, Reconciliation Rules decide which source value 'wins' for each field.",
      "The output is a Unified Individual — one coherent profile representing that person across every connected system.",
    ],
  },
  {
    id: "unified-profile",
    title: "Unified Profile",
    icon: "user-check",
    color: "#22d3ee",
    summary: "The single, harmonized 360° view of a customer — built on Data Model Objects, enriched with Calculated Insights.",
    details: [
      "The Unified Profile combines every mapped attribute and engagement event for a person into one queryable record.",
      "Calculated Insights (like CLV, RFM score, or churn propensity) are computed on top of this unified data and attached back to the profile.",
      "This is the foundation every downstream feature — Segments, AI grounding, Agentforce — is built on.",
    ],
  },
  {
    id: "segment",
    title: "Segmentation",
    icon: "filter",
    color: "#34d399",
    summary: "Group Unified Individuals by attribute, engagement, or Calculated Insight criteria using a drag-and-drop builder.",
    details: [
      "Segments use a rule builder to filter Unified Profiles by any DMO attribute, engagement event, or Calculated Insight.",
      "Segments can combine AND/OR logic plus nested related-object filters (e.g., 'purchased category X in last 30 days AND churn score > 70').",
      "A Segment must be published before its membership can be sent anywhere — publishing computes and locks in the current membership list.",
    ],
  },
  {
    id: "activation",
    title: "Activation",
    icon: "rocket",
    color: "#fbbf24",
    summary: "Send a published Segment's data to an external platform — ads, email, CRM — to actually act on it.",
    details: [
      "An Activation sends a published Segment's membership plus chosen Activation Attributes to a target platform.",
      "Common Activation Targets: Marketing Cloud, Meta/Google/TikTok Ads, Amazon S3, or back into Salesforce CRM.",
      "Activations can run on a schedule tied to the Segment's refresh cadence, so the target platform always has fresh membership.",
    ],
  },
];
